import { render, staticRenderFns } from "./EstimageMessageDetail.vue?vue&type=template&id=55d2095c"
import script from "./EstimageMessageDetail.vue?vue&type=script&lang=js"
export * from "./EstimageMessageDetail.vue?vue&type=script&lang=js"
import style0 from "./EstimageMessageDetail.vue?vue&type=style&index=0&id=55d2095c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55d2095c')) {
      api.createRecord('55d2095c', component.options)
    } else {
      api.reload('55d2095c', component.options)
    }
    module.hot.accept("./EstimageMessageDetail.vue?vue&type=template&id=55d2095c", function () {
      api.rerender('55d2095c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/estimagemessage/EstimageMessageDetail.vue"
export default component.exports